import * as React from "react";
import ReusableTextBlock from "./ReusableTextBlock";
import ImageWithAlt from "./ImageWithAlt";
import ValuesList from "./ValuesList";
import Value from "../../assets/values.png";

function AboutUs() {
  return (
    <div className="flex flex-col items-center mt-16 sm:mt-[100px] pb-12 sm:pb-20 px-4 md:px-8 lg:px-16">
      {/* About Us Heading */}
      <div className="gap-2.5 self-stretch pt-8 sm:pt-16 pb-8 sm:pb-16 text-center text-black uppercase text-3xl sm:text-5xl md:text-7xl lg:text-8xl font-light tracking-wider">
        about us
      </div>

      {/* Hero Image */}
      <ImageWithAlt
        src="https://cdn.builder.io/api/v1/image/assets/9804d3a088fa478e8672485264720a14/b5dcf6fe1b98f09c8c92efddefd21a3f4b63b89aaf6d85874096b9de34aa9917?apiKey=9804d3a088fa478e8672485264720a14&"
        alt="About Bodios"
        className="object-contain w-full max-w-[1911px] aspect-[1.77] rounded-sm"
      />

      {/* Community Section */}
      <div className="max-w-[1273px] w-full mx-auto mt-10 sm:mt-0">
        <ReusableTextBlock
          heading="Community"
          text="Lorem ipsum dolor sit amet consectetur. Ut fermentum dolor nec risus ut ipsum magna. Odio non dictumst curabitur neque fermentum praesent leo sit venenatis. Consectetur et mauris integer at ullamcorper suspendisse ullamcorper euismod dui. Maecenas mattis scelerisque eget nibh non laoreet euismod id sed. Iaculis sit viverra at enim. Dui fringilla ac augue turpis cursus duis. Sed orci quis tortor imperdiet dignissim. Sodales ipsum ipsum rhoncus turpis vivamus diam faucibus interdum. Nunc quam in vitae risus neque diam massa egestas eu. Dolor lectus porttitor diam mi magna. Eu quam sed neque feugiat. Faucibus eleifend suspendisse porta etiam porttitor mauris. Cras."
          headingClasses="text-xl sm:text-2xl md:text-3xl lg:text-4xl font-LibreFranklin"
          textClasses="mt-6 sm:mt-10 md:mt-16 lg:mt-20 text-xs sm:text-sm md:text-base font-light leading-6 sm:leading-7 text-justify"
        />
      </div>

      {/* Founder Section */}
      <div className="mt-12 sm:mt-20 md:mt-32 max-w-[1273px] w-full">
        <div className="flex flex-col md:flex-row gap-5">
          {/* Founder Image */}
          <div className="w-full md:w-6/12">
            <ImageWithAlt
              src="https://cdn.builder.io/api/v1/image/assets/9804d3a088fa478e8672485264720a14/301853821410ddabf31b53aeda5d6dcec8e46ddd6993d29f97e535938f77c32a?apiKey=9804d3a088fa478e8672485264720a14&"
              alt="Our Founder"
              className="object-contain w-full aspect-[0.86] rounded-sm"
            />
          </div>

          {/* Founder Text */}
          <div className="w-full md:w-6/12 mt-80">
            <ReusableTextBlock
              heading="Our founder"
              text="Inspired by the extraordinary qualities of yak down—its inherent warmth, luxury, and softness—J. Ulziibodijav founded BODIOS to bring this unique material to life. With a passion for innovation, he devoted himself to refining yak down’s natural properties, crafting designs that honor both quality and nature’s elegance. By blending tradition with modern techniques, BODIOS has created a collection of yak down garments that are cherished both locally and internationally by those who appreciate unparalleled comfort, quality, and sustainability."
              headingClasses="mt-6 sm:mt-10 md:mt-20 lg:mt-40 text-xl sm:text-2xl md:text-3xl lg:text-4xl"
              textClasses="text-sm sm:text-base md:text-lg font-light leading-6 sm:leading-7 text-justify"
            />
          </div>
        </div>
      </div>

      {/* Philosophy Section */}
      <div className="relative w-full mt-12 sm:mt-16 md:mt-32">
        <ImageWithAlt
          src="https://cdn.builder.io/api/v1/image/assets/9804d3a088fa478e8672485264720a14/298048f44cb87f8a912c8acdf1919739c268f331054c18a3a9d5fa2ee36ac044?apiKey=9804d3a088fa478e8672485264720a14&"
          alt="Philosophy"
          className="object-cover h-[280px] sm:h-[365px] md:h-auto w-full aspect-auto md:aspect-[2.62]"
        />
        <div className="absolute inset-0 flex justify-center px-4 sm:px-6 py-6 sm:py-10 md:p-16 mt-20">
          <div className="max-w-[1273px] w-full">
            <ReusableTextBlock
              heading="Philosophy"
              text="BODIOS crafts products from yak down, offering exceptional warmth, comfort, and environmental sustainability. Committed to ethical business principles that support herders, we strive to bring people closer to nature."
              headingClasses="text-xl sm:text-3xl md:text-4xl lg:text-4xl text-white"
              textClasses="text-xs sm:text-sm md:text-base lg:text-lg font-light leading-5 sm:leading-7 text-white"
            />
          </div>
        </div>
      </div>

      {/* Our Values Section */}
      <div className="flex flex-col mt-12 sm:mt-16 md:mt-32 max-w-[1203px] w-full text-black mx-auto">
        <div className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl text-left">Our values</div>
        <ImageWithAlt
          src={Value}
          alt="Our Values"
          className="object-cover mt-6 sm:mt-10 md:mt-16 w-full"
        />
        <ValuesList />
      </div>
    </div>
  );
}

export default AboutUs;